function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t#tron{fill:#EB0029;}\n");

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "tron",
  className: "st0",
  d: "M1929.1,757.7L332,463.8l840.5,2114.9l1171.1-1426.8L1929.1,757.7z M1903.4,887.2l244.3,232.2l-668.2,121  L1903.4,887.2z M1334.4,1216.2L630.1,632.1l1151.1,211.8L1334.4,1216.2z M1284.2,1319.5l-114.8,949.4L550.2,710.7L1284.2,1319.5z   M1390.5,1369.9l739.9-134l-848.7,1034L1390.5,1369.9z"
});

function SvgIconTronColour(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "\\u56FE\\u5C42_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 2680.2 2915.7",
    style: {
      enableBackground: "new 0 0 2680.2 2915.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTronColour);
export default __webpack_public_path__ + "static/media/icon-tron-colour.dc97ae09.svg";
export { ForwardRef as ReactComponent };